var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "wrap" } }, [
    _c("div", { staticClass: "content_box" }, [
      _c("img", { attrs: { src: _vm.success, alt: "" } }),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            "title",
            { "title-center": _vm.$route.query.isShowScore == 0 }
          ]
        },
        [
          _vm.$route.query.value == 0
            ? _c("h1", [_vm._v("恭喜您，交卷成功！")])
            : _c("h1", [_vm._v("考试时间结束，已自动交卷！")]),
          _vm._v(" "),
          _vm.$route.query.isShowScore != 0
            ? _c("p", [
                _c("span", [_vm._v(_vm._s(_vm.number))]),
                _c("span", [_vm._v("秒后将自动跳转到作答详情页")])
              ])
            : _vm._e()
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c961b218", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c961b218","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/testComponent/testSuccess.vue
// module id = null
// module chunks = 